import { PageHeader } from "../components/layout/PageHeader";
import { IndustriesGrid } from "../components/home/IndustriesGrid";
import { CTASection } from "../components/home/CTASection";
import { IMG } from "../data/content";

export default function Industries() {
  return (
    <main data-testid="industries-page">
      <PageHeader
        eyebrow="Industries"
        title="Solutions for Every Environment"
        subtitle="Whatever your property environment, we tailor our services to meet your operational requirements — across commercial, industrial, residential and public-sector settings."
        image={IMG.heroBuilding}
      />
      <IndustriesGrid compact />
      <CTASection />
    </main>
  );
}
